export default {"src":"/_next/static/media/EMR.9c5dde7c.svg","height":18,"width":18};